import React from "react";
import "./styles.scss";
import { useMutation } from "react-query";
import { fetchSendEmail } from "./api";
import { PageLoader } from "../../components/Loaders/new/PageLoader/PageLoader";
import { tt } from "../../utils/i18n/i18n";
import { useDispatch } from "react-redux";
import { setError, setSuccess } from "../../redux/actions/app";
import KC_Heading2 from "../../designsystem/typography/KC-Heading/KC_Heading2";
import KC_Span from "../../designsystem/KC_Span/KC_Span";
import KC_Colors from "../../designsystem/KC_Colors";

export const Contact = () => {
  const dispatch = useDispatch();
  const {
    mutate: sendEmailMut,
    isLoading: sendEmailLoad,
    error: sendEmailErr
  } = useMutation(fetchSendEmail, {
    onSuccess() {
      dispatch(setSuccess(tt("api_send_email_success")));
    }
  });

  if (sendEmailErr) {
    dispatch(setError(tt("api_send_email_error")));
  }

  return (
    <div className="contact rounded-box card-padding">
      {sendEmailLoad ? (
        <PageLoader />
      ) : (
        <>
          <div className="contact-heading-big">
            <KC_Heading2 text={tt("a_question")} />
          </div>
          <div className="contact-heading-small">
            <div className="contact-subheading">
              <KC_Span
                className="kc-span-big"
                text={tt("send_email")}
                color={KC_Colors.Blue}
              />
              <KC_Span
                className="kc-span-big"
                color={KC_Colors.Red}
                href={`mailto:${tt("support_email")}`}
                text={tt("support_email")}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
